import P from '@components/Components/Reusables/Typography/P'
import Box from '@mui/material/Box';
import Image from 'next/image';
import React, { useState } from 'react'

export default function PackageCoreColours(props) {
    const {
        selectedColour,
        setSelectedColour,
        finishes = [],
        product_finishes = []
    } = props;

    const [oranisedFinishes] = useState(() => {
        // console.log(finishes, product_finishes)
        const complete_finishes = [];

        finishes.map(finish => {
            const linked_finish = product_finishes.find(new_finish => new_finish.product_code == finish.doris_product_code)
            complete_finishes.push({
                ...linked_finish,
                ...finish,
            })
        })
        return complete_finishes
    })
  
    // console.log(oranisedFinishes[0])
    
    return (
        <div className="pl-2">
            <P color="secondary" className="fw-bold">Choose finish:</P>
            <div 
                className="d-flex grid finish-width" 
                style={{gap: '12px'}}
            >
                {
                    oranisedFinishes?.map(finish => (
                        <div 
                            className={`${selectedColour.label == finish.name ? 'bg-secondary package-core-box-active' : ''} pointer`} 
                            key={finish.name} 
                            style={{ border: '1px solid black', borderRadius: '6px', padding: '6px' }}
                            onClick={() => {
                                setSelectedColour({
                                    slug: finish.product_slug,
                                    label: finish.name,
                                    qty: 1
                                })
                            }} 
                        >
                            <p className="text-center fw-bold pb-0 mb-0">{finish.name}</p>
                            <p className="text-center fw-semi-bold fs-10 pt-0 mt-0">{finish?.finish_subheader} &nbsp;</p>
                            <div className="position-relative" style={{height: '200px', width: '150px'}}>
                                <Image 
                                    src={finish.image}
                                    fill
                                    style={{
                                        objectFit: 'cover',
                                        borderRadius: '6px'
                                    }}
                                    sizes="300px"
                                    alt={`${finish.name} Finish`}
                                />
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
